const leasingModal = document.querySelector(".leasing-modal-wrapper");

export const leasingTerms = () => {
  const leasingTermsContainer = document.querySelector('div.leasing-modal-wrapper');
  if (leasingTermsContainer) {
    const closeBtn = leasingTermsContainer.querySelector('svg.close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        //window.parent.postMessage(`leasing_terms_close_clicked`);
        leasingModal.classList.toggle('open');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/templates/components/leasing-terms/leasing-terms.js